import React, { useEffect, useMemo, useRef, useState } from 'react';
import Select from 'react-select';
import close from '../../../assets/icons/close.svg';
import { getData, Postdata, Postdataform } from '../../../API/GlobalApi';
import { reactSelectStyles } from '../../../Utils/selectBoxStyle';
import '../../../assets/css/Modal.css';
import { useNavigate } from 'react-router-dom';

import nocourseImg from '../../../assets/Images/no-course-removebg-preview.png'
import FeePlanModal from '../../../Component/Modals/FeePlanShowModal';
import AddFeeHeadModal from '../../../Component/Modals/AddFeeHead';
import ConfirmationModal from '../../../Component/Modals/ConfirmationModal';
import Notifier from '../../../Utils/notify';
import OtpModal from '../../../Component/Modals/DiscountOtpInput';
import { DiscountPreviewModal } from '../../../Component/Modals/DiscountPreview';
import { v4 as uuidv4 } from "uuid";
import { generateDiscountPDF } from '../../../Utils/generatePdfForTemplateSent';

import { WaitFeeApprovalsModal } from '../../../Component/Modals/WaitApprovalForFeeTemplate';
import { numberToWords } from '../../../Utils/convertNumtoWord';



export const AddDiscount = () => {
    const [courseData, setCourseData] = useState([]);
    const [courseOptions, setCourseOptions] = useState([]);
    const [semesterOptions, setSemesterOptions] = useState([]);
    const [sectionOptions, setSectionOptions] = useState([]);
    const [selectedCourse, setSelectedCourse] = useState(null);
    const [selectedSemesters, setSelectedSemesters] = useState([]);
    const [selectedSemester, setSelectedSemester] = useState([]);
    const [selectedSections, setSelectedSections] = useState([]);
    const [allCourseStudents, setAllCourseStudents] = useState([]);
    const [students, setStudents] = useState([]);
    const [selectedStudent, setSelectedStudent] = useState([]);
    const [selectedStudentFeePlan, setSelectedStudentFeePlan] = useState([]);
    const [searchTerm, setSearchTerm] = React.useState("");
    const [helpdeskperson, setHelpDeskPerson] = useState([]);
    const [selectedEmployeeIds, setSelectedEmployeeIds] = useState([]);
    const [showStudents, setShowStudents] = useState(false);
    const [sessions, setSessions] = useState([]);
    const [selectedSession, setSelectedSession] = useState(null);

    const getSessions = async () => {
        const response = await getData("academics/academic-years/");
        const options = response?.map((session) => ({
            value: session.id,   // This is what you'll send when selected
            label: session.name, // This is what user will see
            is_current: session.is_current,
        }));

        setSessions(options);

        // Find the default session where is_current is true
        const currentSession = options.find((opt) => opt.is_current);

        if (currentSession) {
            setSelectedSession(currentSession);
        }
    };

    useEffect(() => {
        getSessions();
    }, []);



    const gethelpdeskPerson = async () => {
        const url = "finance/course-fee-plans/authorized-employees/?type=discount";
        const response = await getData(url);
        setHelpDeskPerson(response?.authorized_employees)
    }

    // const [selectedFeeHeads, setSelectedFeeHeads] = useState([]);
    // const [paymentTypes, setPaymentTypes] = useState([]);
    const [selectedFeeHeads, setSelectedFeeHeads] = useState(null);
    const [paymentTypes, setPaymentTypes] = useState([]);


    const getFeeTypes = async (courseId) => {
        if (!courseId) return;

        const url = `finance/available-fee-head-types/${courseId}/`;
        const res = await getData(url);

        const options = res?.map((i) => ({
            label: i.name,
            value: i.id
        })) || [];

        setPaymentTypes(options);
    };


    // const handleChange = (selected) => {
    //     if (!selected) {
    //         setSelectedFeeHeads([]);
    //         return;
    //     }

    //     // check if "Select All" is clicked
    //     if (selected.some((s) => s.value === "ALL")) {
    //         if (selectedFeeHeads.length === paymentTypes.length - 1) {
    //             setSelectedFeeHeads([]); // unselect all
    //         } else {
    //             // select all except "ALL"
    //             setSelectedFeeHeads(paymentTypes.filter((p) => p.value !== "ALL").map(p => p.value));
    //         }
    //     } else {
    //         setSelectedFeeHeads(selected.map(s => s.value));
    //     }
    // };

    const handleChange = (selected) => {
        if (!selected) {
            setSelectedFeeHeads(null);
            return;
        }

        setSelectedFeeHeads(selected.value);
    };


    //  
    // Fetch course list
    useEffect(() => {


        const fetchData = async () => {

            if (!selectedSession) return; // wait until session is selected
            // Reset selections
            // setSelectedCourse(null);
            // setSelectedSemester(null);
            // setSelectedSections([]);
            // setSemesterOptions([]);
            // setSectionOptions([]);
            // setStudents([]);
            // setAllCourseStudents([]);
            // setSelectedStudent([]);
            setShowStudents(false);
            // const query = `?academic_year_id=${selectedSession.value}`;

            const res = await getData(`finance/specializations/`);
            if (Array.isArray(res)) {
                setCourseData(res);
                setCourseOptions(res.map(c => ({ value: c.id, label: c.full_name })));
            }

        };
        gethelpdeskPerson()
        fetchData();
        getFeeTypes()
    }, []);



    useEffect(() => {
        if (selectedCourse?.value) {
            getFeeTypes(selectedCourse.value);
        }
    }, [selectedCourse]);

    // 🔹 Fetch courses, fee types, helpdesk
    useEffect(() => {
        const fetchData = async () => {
            const res = await getData("finance/specializations/");
            if (Array.isArray(res)) {
                setCourseData(res);
                setCourseOptions(res.map(c => ({ value: c.id, label: c.full_name })));
            }
        };
        gethelpdeskPerson();
        fetchData();
        getFeeTypes();
    }, []);

    // 🔹 Load fee types when course changes
    useEffect(() => {
        if (selectedCourse?.value) {
            getFeeTypes(selectedCourse.value);
        }
    }, [selectedCourse]);

    // 🔹 When course changes → collect semesters + students
    useEffect(() => {
        if (!selectedCourse) {
            setSemesterOptions([]);
            setSectionOptions([]);
            // setSelectedFeeHeads([])
            setOccurrence("")
            setSelectedFeeHeads(null);
            setPaymentTypes([])
            setAllCourseStudents([]);
            setSelectedStudent([]); // clear selection
            setShowStudents(false);
            return;
        }

        const course = courseData.find(c => c.id === selectedCourse.value);

        if (course?.academic_groups) {
            setSemesterOptions(course.academic_groups.map(s => ({
                value: s.id,
                label: s.name
            })));

            const courseStudents = course.academic_groups.flatMap(semester =>
                semester.lags?.flatMap(section =>
                    section.students?.map(stu => ({
                        id: stu.user_id,
                        name: stu.full_name,
                        rollNumber: stu.permanent_registration_number,
                        balance: stu.balance,
                        semester: semester.id,
                        semesterName: semester.name,
                        section: section.id,
                        sectionName: section.name,
                        mobile_number: stu.mobile_number,
                        courseId: course.id,
                        feeSchedules: stu.fee_schedules || []
                    }))
                ) || []
            );

            setAllCourseStudents(courseStudents);

            // ✅ Auto-select all students on course change
            setSelectedStudent(courseStudents.map(s => s.id));
            setShowStudents(false);
        } else {
            setSemesterOptions([]);
            setAllCourseStudents([]);
            setSelectedStudent([]);
            setShowStudents(false);
        }

        setSelectedSemester(null);
        setSelectedSections([]);
        setSelectedStudent([]);
        setSectionOptions([]);
    }, [selectedCourse, courseData]);

    // 🔹 When semester changes → update sections & auto-select students
    useEffect(() => {
        if (!selectedCourse || !selectedSemester) {
            setSectionOptions([]);
            setSelectedSections([]);
            setSelectedStudent(allCourseStudents.map(s => s.id)); // select all course students
            setSelectedStudent([]); // reset
            return;
        }

        const course = courseData.find(c => c.id === selectedCourse.value);
        const semesterData = course?.academic_groups.find(s => s.id === selectedSemester.value);

        setSectionOptions(
            semesterData?.lags?.map(sec => ({ value: sec.id, label: sec.name })) || []
        );
        setSelectedSections([]);

        // ✅ Auto-select all semester students
        const semesterStudents = allCourseStudents.filter(stu => stu.semester === Number(selectedSemester.value));
        setSelectedStudent(semesterStudents.map(s => s.id));
        // setSelectedStudent([]); // ✅ no auto select
    }, [selectedSemester, selectedCourse, allCourseStudents, courseData]);

    // 🔹 When sections change → auto-select section students
    useEffect(() => {
        if (!selectedCourse || !selectedSemester) {
            return;
        }

        if (selectedSections?.length) {
            const sectionIds = selectedSections.map(s => s.value);
            const sectionStudents = allCourseStudents.filter(stu =>
                stu.semester === Number(selectedSemester.value) &&
                sectionIds.includes(stu.section)
            );
            setSelectedStudent(sectionStudents.map(s => s.id));
        } else {
            // if no section selected → select all students of that semester
            const semesterStudents = allCourseStudents.filter(stu => stu.semester === Number(selectedSemester.value));
            setSelectedStudent(semesterStudents.map(s => s.id));
        }
    }, [selectedSections, selectedSemester, selectedCourse, allCourseStudents]);

    // 🔹 Final filtered students (no side effects, just filtering)
    const filteredStudents = useMemo(() => {
        let result = [...allCourseStudents];

        if (selectedCourse) {
            result = result.filter(stu => stu.courseId === Number(selectedCourse.value));
        }
        if (selectedSemester) {
            result = result.filter(stu => stu.semester === Number(selectedSemester.value));
        }
        if (selectedSections?.length) {
            const sectionIds = selectedSections.map(s => s.value);
            result = result.filter(stu => sectionIds.includes(stu.section));
        }
        // if (selectedFeeHeads.length > 0) {
        //     result = result.filter(stu => {
        //         const studentHeads = (stu.feeSchedules || []).map(fs => String(fs.fee_type_head_pk));

        //         // student must contain ALL selected fee heads
        //         return selectedFeeHeads.every(h => studentHeads.includes(String(h)));
        //     });
        // }
        if (selectedFeeHeads) {
            result = result.filter(stu => {
                const studentHeads = (stu.feeSchedules || []).map(fs =>
                    String(fs.fee_type_head_pk)
                );
                return studentHeads.includes(String(selectedFeeHeads));
            });
        }


        // 🔹 Apply search filter
        if (searchTerm) {
            const term = searchTerm.toLowerCase();
            result = result.filter(stu =>
                stu.name?.toLowerCase().includes(term) ||
                stu.rollNumber?.toLowerCase().includes(term) ||
                stu.mobile_number?.toString().includes(term) ||
                stu.email?.toLowerCase().includes(term)
            );
        }

        result.sort((a, b) => a.name.localeCompare(b.name));


        return result;
    }, [
        allCourseStudents,
        selectedCourse,
        selectedSemester,
        selectedSections,
        selectedFeeHeads,
        searchTerm
    ]);



    const [feeRow, setFeeRow] = useState({
        semester: null,
        feeHead: null,
        amount: "",
        discountName: "",         // ← NEW
        applicationFile: null
    });

    const [occurrence, setOccurrence] = useState("one_time"); // "one_time" | "each_time"
    // const [selectedSemesters, setSelectedSemesters] = useState([]); // for checkboxes



    const [feeHeadOptions, setFeeHeadOptions] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        const getFeeTypes = async () => {
            try {
                const res = await getData('students/get-payment-types/');

                let options = (res?.fee_heads || []).map(t => ({
                    label: t.name,
                    value: t.id
                }));

                // Append special option
                options.push({ label: "+ Add Fee Head", value: "__add__" });

                setFeeHeadOptions(options);
            } catch (err) {
                setFeeHeadOptions([{ label: "+ Add Fee Head", value: "__add__" }]);
            }
        };
        getFeeTypes();
    }, []);


    // const getClasses = async () => {
    //     const response = await getData('finance/specializations')
    //     setCourseData(response || []);
    // }
    // useEffect(() => {
    //     getClasses()
    // }, [])

    const toggleAll = (e, studentsToSelect) => {
        if (e.target.checked) {
            const selectableIds = studentsToSelect.map(s => s.id);
            setSelectedStudent(selectableIds);

        } else {
            setSelectedStudent([]);

        }
    };

    const toggleOne = (id) => {
        setSelectedStudent(prev => prev.includes(id) ? prev.filter(sid => sid !== id) : [...prev, id]);
    };

    const [isSubmitting, setIsSubmitting] = useState(false);

    const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);
    const [otpModalOpen, setOtpModalOpen] = useState(false);
    // This function triggers the modal opening


    const [previewData, setPreviewData] = useState(null);
    const [previewOpen, setPreviewOpen] = useState(false);


    const handleBeforeSubmit = () => {
        // prepare preview data first
        const studentIds = selectedStudent.filter(id =>
            filteredStudents.some(stu => stu.id === id)
        );

        if (!studentIds.length) {
            Notifier.error("Please select at least one student");
            return;
        }

        const selectedStudentsData = filteredStudents.filter(stu =>
            studentIds.includes(stu.id)
        );

        // const feeHeadNames = paymentTypes
        //     .filter(p => selectedFeeHeads.includes(p.value))
        //     .map(p => p.label);

        // const feeHeadNames = selectedFeeHeads ? [selectedFeeHeads.label] : [];

        const selectedFeeHeadObj = paymentTypes.find(
            p => p.value === selectedFeeHeads
        );

        const feeHeadNames = selectedFeeHeadObj ? [selectedFeeHeadObj.label] : [];
        // 🔹 Decide planMode
        const planMode =
            studentIds.length === filteredStudents.length
                ? "course"
                : "individual";


        if (occurrence === "each_time" && !selectedSemesters.length) {
            Notifier.error("Please select at least one semester");
            return;
        }

        // Get occurrence semester objects (for preview UI)
        const occurrenceSemesterObjects =
            occurrence === "each_time"
                ? semesterOptions.filter(sem =>
                    selectedSemesters.includes(sem.value)
                )
                : [];

        setPreviewData({
            students: selectedStudentsData,
            feeHeadNames,
            discountAmount: feeRow.amount,
            mode: planMode,
            selectedCourse,
            selectedSemester,
            occurrence,
            // ✅ for preview display
            occurrenceSemesters: occurrenceSemesterObjects,
            feeRow,
            payload: {
                student_ids: studentIds.join(","),
                academic_group_id: selectedSemester?.value,
                // fee_head_ids: selectedFeeHeads.join(","),
                fee_head_ids: String(selectedFeeHeads), // ✅ FIXED
                discount: feeRow.amount,
                employee_ids: selectedEmployeeIds.join(","),
                plan_mode: planMode, // 👈 also include in payload if API expects it
                // discount_name: feeRow.discountName || "",
                // application_file: feeRow.applicationFile || null,

                occurrence, // ✅ NEW
                occurrence_semester_ids:
                    occurrence === "each_time"
                        ? selectedSemesters.join(",")
                        : null

            }
        });

        setPreviewOpen(true); // open preview modal
    };


    // Called when user confirms inside the modal



    const handleConfirmFeePlan = async () => {
        setIsSubmitting(true); // show loader

        try {
            await handleSubmit();
        } finally {
            setIsSubmitting(false); // hide loader always
            setConfirmationModalOpen(false); // close confirmation after response
        }
    };

    // Called when user cancels inside the modal
    const handleCancelFeePlan = () => {
        setConfirmationModalOpen(false);
    };

    const [studentResponse, setStudentResponse] = useState('')

    const handleConfirmOtp = async (otpCode) => {
        // if (!studentResponse?.unique_id) {

        //     console.error("No unique_id found in studentResponse:", studentResponse);
        //     Notifier.error("Student Unique ID is missing. Cannot verify OTP.");
        //     return;
        // }

        const url = 'finance/verify-discount-otp/';
        const payload = {
            unique_id: studentResponse.unique_id,
            otp: otpCode
        };

        try {
            const response = await Postdata(url, payload);
            // Check if API returned an error in the response
            if (response?.error) {
                Notifier.error(response.error); // show error from API
                return; // stop further execution
            }

            // Success path
            Notifier.success("Discount approved successfully");
            setOtpModalOpen(false);
            navigate(-1);
        } catch (error) {
            console.error("Error verifying OTP:", error);
            Notifier.error(error?.message || "Failed to verify OTP");
        }
    };

    // Step 5: Cancel OTP modal
    const handleCancelOtp = () => {
        setOtpModalOpen(false);
        navigate(-1)
    };






    const handlesResendOtpToAssignedPerson = async () => {
        const url = 'finance/resend-discount-otp/';
        const payload = {
            unique_id: studentResponse.unique_id,
            employee_ids: selectedEmployeeIds.join(",")
        };

        try {
            const response = await Postdata(url, payload);
            if (!response?.error) {
                setStudentResponse({
                    otp: response.otp, unique_id: studentResponse.unique_id, signed_urls: studentResponse?.signed_urls
                })
                Notifier.success(response.message || "OTP resent successfully!");
            } else {
                Notifier.error(response.message || "Failed to resend OTP.");
            }
        } catch (error) {

            const errorMessage =
                error?.response?.data?.message ||
                error?.message ||
                "Something went wrong. Please try again.";
            Notifier.error(errorMessage);
        }
    };

    const [showWaittingModal, setShowWaitingModal] = useState(false)

    const handleSubmit = async () => {
        try {
            const studentIds = selectedStudent.filter(id =>
                filteredStudents.some(stu => stu.id === id)
            );

            if (!studentIds.length) {
                Notifier.error("Please select at least one student");

                return;
            }
            const basePayload = {
                student_ids: studentIds.join(","),
                academic_group_id: selectedSemester?.value,
                // fee_head_ids: selectedFeeHeads.join(","),
                fee_head_ids: selectedFeeHeads ? String(selectedFeeHeads) : "",
                discount: feeRow.amount,
                employee_ids: selectedEmployeeIds.join(","),
                discount_name: feeRow.discountName || "",
                // application_file: feeRow.applicationFile || null,/
                occurrence,
                occurrence_semester_ids:
                    occurrence === "each_time"
                        ? selectedSemesters.join(",")
                        : null,
            };
            const uniqueFileName = uuidv4().replace(/-/g, "").slice(0, 20);
            const selectedStudentsData = filteredStudents.filter(stu =>
                studentIds.includes(stu.id)
            );

            const approvedByNames = selectedEmployeeIds
                .map(id => helpdeskperson.find(p => p.id === id)?.name)  // find name by id
                .filter(Boolean)  // remove undefined
                .join(", ");

            const pdfBlob = generateDiscountPDF(
                previewData,
                approvedByNames,
                selectedSession?.label
            );

            // const fileUrl = await uploadToS3(pdfBlob, `discount_${uniqueFileName}.pdf`);
            // if (!fileUrl) throw new Error("File upload failed — S3 URL not received.");
            const approvalUrl = `${process.env.REACT_APP_WINDOW_BASEURL2}fee/discount-approvals/${uniqueFileName}`;

            const formData = new FormData();
            formData.append("document_url", pdfBlob, `discount_${uniqueFileName}.pdf`);
            // formData.append("application_file", feeRow.applicationFile);
            // Application File Upload (optional)
            if (feeRow.applicationFile) {
                const fileExt = feeRow.applicationFile.name.split(".").pop();

                // same UUID for file name
                const appFileName = `${uniqueFileName}.${fileExt}`;

                formData.append("application_file", feeRow.applicationFile, appFileName);

                // SAME unique id goes here
                formData.append("document_uuid", uniqueFileName);
            } else {
                // Still append UUID for backend consistency
                formData.append("document_uuid", uniqueFileName);
            }

            const payloadWithDoc = {
                ...basePayload,
                // document_url: fileUrl,
                document_uuid: uniqueFileName,
                approval_url: approvalUrl
            };
            Object.entries(payloadWithDoc).forEach(([key, value]) => {
                if (typeof value === "object" && value !== null) {
                    formData.append(key, JSON.stringify(value));
                } else {
                    formData.append(key, value);
                }
            });

            console.log("🔍 FORM DATA CONTENTS:");
            for (let pair of formData.entries()) {
                console.log(pair[0] + " → ", pair[1]);
            }

            const response = await Postdataform('finance/add-fee-discount/', formData);
            if (response.error) {
                const errorMessage = Array.isArray(response.error)
                    ? response.error[0] // get first element
                    : response.error;
                Notifier.error(errorMessage);
            } else {
                setStudentResponse({
                    unique_id: response.unique_id,
                    message: response.message,
                    otp: response.otp,
                    signed_urls: response?.signed_urls

                })
                // setOtpModalOpen(true);
                setShowWaitingModal(true)

                // Notifier.success("OTP Sent successfully");


            }

        } catch (error) {
            console.error("Error submitting fee plan:", error);
            Notifier.error("Failed to submit fee plan. Please try again.");
        }
    };



    const handleCancel = () => {
        setSelectedCourse('')
        setSelectedStudent('');
        setSelectedSemester('')
        setSelectedSections('')
        setSelectedStudent('')
        setSelectedEmployeeIds('')
        // setHelpDeskPerson([])
        // setAmount('');
        // setScheduledDate('');
        // setPenaltyAmountFixed('');
        // setInlineActionSelected('due'); // or default
        // setImposePenalty(false);
        // setSelectedStudent([]);
        // setFixedError('');

    };

    const [showFeePlanModal, setShowFeePlanModal] = useState(false);
    const [selectedFeePlan, setSelectedFeePlan] = useState(null);
    const [selectedStudentName, setSelectedStudentName] = useState('');

    const isFormValid =
        feeRow.discountName?.trim() &&              // discount name
        feeRow.applicationFile !== null &&          // application file
        feeRow.amount?.trim() &&                    // discount amount
        selectedEmployeeIds?.length > 0
    // &&          // at least one employee
    // occurrence &&                               // occurrence selected
    // (
    //     occurrence !== "each_time" ||           // if not each_time → OK
    //     selectedSemesters?.length > 0            // if each_time → semesters required
    // )



    const dashboardRef = useRef(null);
    return (
        <>
            <div style={{
                display: "flex",
                flexDirection: "column",
                height: "100vh",
                overflow: "hidden",
            }}>
                {/* <div className="dashboard discount-dashboard" ref={dashboardRef} style={{ paddingLeft: '25px', zIndex: 1 }}> */}
                {/* Content for the Dashboard */}
                <div style={{ flexShrink: 0, padding: "0 12px" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        {/* Left side: SVG + heading */}
                        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                            <button
                                onClick={() => navigate(-1)}
                                style={{
                                    background: "transparent",
                                    border: "none",
                                    cursor: "pointer",
                                    padding: 0
                                }}
                                title="Go back"
                            ><svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="32"
                                height="32"
                                fill="none"
                                stroke="#7F56DA"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                style={{ marginTop: '10px' }}
                            >
                                    <line x1="19" y1="12" x2="5" y2="12"></line>
                                    <polyline points="12 19 5 12 12 5"></polyline>
                                </svg>

                            </button>

                            <h2 className='main-heading' style={{ margin: 0, color: "#7F56DA" }}>Create Discount</h2>
                        </div>

                        {/* Right side: Academic Year */}
                        {/* <div>
                        <label className="form-labell">Admission Academic Year</label>
                        <Select
                            options={sessions}
                            value={selectedSession}
                            onChange={opt => setSelectedSession(opt)}
                            styles={reactSelectStyles}
                            placeholder="Select Session"
                            // isClearable
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                        // isDisabled={true}
                        />

                    </div> */}
                    </div>
                </div>


                <div
                    className='scheduleconainer'
                    style={{
                        flex: 1,
                        overflowY: "auto",
                        overflowX: "hidden",
                        minHeight: 0,
                        padding: "20px",
                        scrollbarGutter: "stable",
                    }}>

                    <div className="row mt-2">
                        <div className='col-md-12'>
                            <div className="row mt-3 d-flex justify-content-start align-items-center">

                                {/* <div className="col-md-3">
                                <label className="form-labell">Academic Year</label>
                                <Select
                                    options={sessions}
                                    value={selectedSession}
                                    onChange={(opt) => setSelectedSession(opt)}
                                    styles={reactSelectStyles}
                                    placeholder="Select Session"
                                    isClearable
                                    menuPortalTarget={document.body}
                                    menuPosition="fixed"
                                />

                            </div> */}
                                <div className="col-md-4">
                                    <label className="form-labell">Course<span className="astrisk">*</span></label>
                                    <Select
                                        value={selectedCourse}
                                        onChange={(opt) => setSelectedCourse(opt)}
                                        options={courseOptions}
                                        styles={reactSelectStyles}
                                        placeholder="Select Course"
                                        isClearable
                                        menuPortalTarget={document.body}
                                        menuPosition="fixed"

                                    />
                                </div>
                                <div className="col-md-4">
                                    <label className="form-labell">Select Semester<span className="astrisk">*</span></label>
                                    <Select
                                        value={selectedSemester}
                                        onChange={(opts) => setSelectedSemester(opts || [])}
                                        options={semesterOptions}
                                        styles={reactSelectStyles}
                                        placeholder="Select Semester(s)"
                                        isClearable
                                        isDisabled={!semesterOptions.length}
                                        menuPortalTarget={document.body}
                                        menuPosition="fixed"
                                    />
                                </div>

                                <div className="col-md-4">
                                    <label className="form-labell">Section</label>
                                    <Select
                                        value={selectedSections}
                                        onChange={(opts) => setSelectedSections(opts || [])}
                                        options={sectionOptions}
                                        styles={reactSelectStyles}
                                        placeholder="Select Section(s)"
                                        isMulti
                                        isDisabled={!sectionOptions.length}
                                        menuPortalTarget={document.body}
                                        menuPosition="fixed"
                                    />

                                </div>
                            </div>
                            <div className=' '>
                                {!selectedCourse ? (
                                    // CASE 1: No course selected
                                    <>
                                        <div
                                            className="col-12 d-flex flex-column align-items-center justify-content-center mt-5 sections"
                                            style={{ minHeight: 420, textAlign: 'center', color: '#6c757d' }}
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="80"
                                                height="80"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="#6c757d"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            >
                                                <path d="M21 21l-4.35-4.35"></path>
                                                <circle cx="10" cy="10" r="7"></circle>
                                                <line x1="14" y1="10" x2="14" y2="10"></line>
                                            </svg>
                                            <p className="mt-3" style={{ fontSize: '18px', fontWeight: 500 }}>
                                                No records found
                                            </p>
                                            <p className="text-muted" style={{ fontSize: '14px' }}>
                                                Please select a course to view students.
                                            </p>
                                        </div>
                                    </>
                                ) : (

                                    <>
                                        <div className="row mt-3 sections">
                                            <div className="col-md-4 mt-3">

                                                <label className="form-labell">
                                                    Select Fee Head<span className="astrisk">*</span>
                                                </label>
                                                <Select
                                                    // isMulti
                                                    styles={reactSelectStyles}
                                                    options={paymentTypes}
                                                    // value={paymentTypes.filter(p => selectedFeeHeads.includes(p.value))}
                                                    value={paymentTypes.find(p => p.value === selectedFeeHeads) || null}
                                                    onChange={handleChange}
                                                    placeholder="Search or select fee heads..."
                                                    menuPortalTarget={document.body}   // ✅ attach dropdown to body
                                                    menuPosition="fixed"
                                                // closeMenuOnSelect={false}
                                                />
                                            </div>


                                            <div className="col-md-12 d-flex align-items-center gap-2 mt-3 mb-3">
                                                <div className="form-check form-switch custom-switch">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        role="switch"
                                                        style={{ cursor: 'pointer', zIndex: 1 }}
                                                        checked={showStudents} // controlled by state
                                                        onChange={() => setShowStudents(prev => !prev)} // toggle
                                                    />
                                                    <label className="form-check-label">
                                                        {showStudents ? "Hide Student List" : "Show Student List"}
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mt-2 d-flex justify-content-start">
                                            {showStudents && (
                                                <div className="col-md-12">
                                                    <div className="row mt-4 align-items-center">
                                                        <div className="col-md-6 d-flex align-items-center">
                                                            <h5 className="mb-0">Select Students</h5>
                                                        </div>
                                                        <div className="col-md-6 d-flex align-items-center justify-content-end">
                                                            <span className="text-muted small">
                                                                {selectedStudent?.length} / {filteredStudents?.length} selected
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div
                                                        className="feePlanTableContainer mt-1"
                                                        style={{ maxHeight: '300px', overflowY: 'auto', flexShrink: '0' }}
                                                    >
                                                        <table className="table table-bordered mt-2 feeplantables">
                                                            <thead
                                                                style={{ position: "sticky", top: 0, background: "#fff", zIndex: 2 }}
                                                            >
                                                                <tr>
                                                                    <th style={{ width: 40 }}>
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={
                                                                                filteredStudents.length > 0 &&
                                                                                selectedStudent.length === filteredStudents.length
                                                                            }
                                                                            onChange={(e) => toggleAll(e, filteredStudents)}
                                                                        />
                                                                    </th>

                                                                    <th style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '8px', justifyContent: 'space-between' }}>
                                                                        Student Name (Registration No.)
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            placeholder="Search students by name,registration number,mobile number.."
                                                                            value={searchTerm}
                                                                            onChange={(e) => setSearchTerm(e.target.value)}
                                                                            style={{ maxWidth: '480px', height: '30px', fontSize: '14px' }}
                                                                        />
                                                                    </th>

                                                                    <th>Course</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {filteredStudents.length > 0 ? (
                                                                    filteredStudents.map((stu) => (
                                                                        <tr key={stu.id}>

                                                                            <td>
                                                                                <input
                                                                                    type="checkbox"
                                                                                    checked={Array.isArray(selectedStudent) && selectedStudent.includes(stu.id)}
                                                                                    onChange={() => {
                                                                                        setSelectedStudent((prev) =>
                                                                                            Array.isArray(prev)
                                                                                                ? prev.includes(stu.id)
                                                                                                    ? prev.filter((id) => id !== stu.id)
                                                                                                    : [...prev, stu.id]
                                                                                                : [stu.id]
                                                                                        );
                                                                                    }}
                                                                                />

                                                                            </td>
                                                                            <td style={{
                                                                                display: 'flex',
                                                                                justifyContent: 'space-between',
                                                                                alignItems: 'center'

                                                                            }}>
                                                                                <p className="d-flex flex-column">
                                                                                    <span style={{ fontSize: '13px', fontWeight: 600 }}>{stu.name}</span>
                                                                                    {stu.rollNumber && (
                                                                                        <span style={{ fontSize: '13px', }}>
                                                                                            ({stu.rollNumber})
                                                                                        </span>
                                                                                    )}
                                                                                </p>


                                                                            </td>
                                                                            <td style={{
                                                                                fontSize: '13px'
                                                                            }}>
                                                                                {selectedCourse?.label || "—"} |{" "}
                                                                                {stu.semesterName || "—"} |{" "}
                                                                                {stu.sectionName || "—"}
                                                                            </td>
                                                                        </tr>
                                                                    ))
                                                                ) : (
                                                                    <tr>
                                                                        <td colSpan="3" className="text-center text-muted">
                                                                            No student details found
                                                                        </td>
                                                                    </tr>
                                                                )}
                                                            </tbody>



                                                        </table>
                                                    </div>
                                                </div>)}
                                        </div>
                                    </>
                                )}
                            </div>
                            <div className="row mt-2 d-flex justify-content-start">
                                <div className="col-md-12">
                                    {selectedStudent?.length > 0 && (
                                        <>
                                            {/* Title row */}
                                            <div className="row mt-1 align-items-center justify-content-center">
                                                <div className="col-12 text-start">
                                                    <h5 className="mb-1">Select Details</h5>
                                                </div>
                                            </div>

                                            {/* Fee rows */}
                                            {/* Single Fee Row */}
                                            <div className="row mb-2 mt-1 align-items-center">

                                                <div className="col-md-4">
                                                    <label className="form-labell">Discount Name<span className="astrisk">*</span></label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter Discount Name"
                                                        style={{ height: "45px" }}
                                                        value={feeRow.discountName}
                                                        onChange={(e) =>
                                                            setFeeRow({ ...feeRow, discountName: e.target.value })
                                                        }
                                                    />
                                                </div>
                                                <div className="col-md-4">
                                                    <label className="form-labell">Upload Document<span className="astrisk">*</span></label>
                                                    {/* <input
                                                    type="file"
                                                    className="form-control"
                                                    accept="image/*"        // ✅ Accept only images
                                                    onChange={(e) =>
                                                        setFeeRow({ ...feeRow, applicationFile: e.target.files[0] })
                                                    }
                                                /> */}
                                                    <input
                                                        type="file"
                                                        className="form-control"
                                                        accept=".jpg,.jpeg,.png"  // ✅ Specific image formats only
                                                        onChange={(e) => {
                                                            const file = e.target.files[0];
                                                            // Optional: Additional validation
                                                            if (file) {
                                                                const validTypes = ['image/jpeg', 'image/jpg', 'image/png'];
                                                                if (!validTypes.includes(file.type)) {
                                                                    Notifier.info('Please upload only JPG, PNG,  images');
                                                                    e.target.value = ''; // Clear the input
                                                                    return;
                                                                }
                                                                setFeeRow({ ...feeRow, applicationFile: file });
                                                            }
                                                        }}
                                                    />

                                                </div>

                                            </div>


                                            <div className="row mb-2 mt-1 align-items-center">

                                                <div className="col-md-4">

                                                    <label className="form-labell mb-2">
                                                        Discount Amount<span className="astrisk">*</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Amount"
                                                        value={feeRow.amount}
                                                        onChange={(e) => {
                                                            let value = e.target.value;
                                                            if (/^\d{0,7}(\.\d{0,2})?$/.test(value)) {
                                                                setFeeRow({ ...feeRow, amount: value });
                                                            }
                                                        }}
                                                        style={{ height: "45px" }}
                                                        onKeyDown={(e) => {
                                                            if (["e", "E", "+", "-", "/", "*", "_"].includes(e.key)) {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                    />
                                                    {/* SHOW AMOUNT IN WORDS */}
                                                    {feeRow.amount && !isNaN(Number(feeRow.amount)) && (
                                                        <small style={{ color: "#7F56DA", fontWeight: 600 }}>
                                                            {numberToWords(Number(feeRow.amount))} only
                                                        </small>
                                                    )}
                                                </div>
                                                <div className="col-md-4" style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', gap: '16px' }}>
                                                    <div style={{ flex: 1 }}>
                                                        <label className="form-labell mb-2">
                                                            Discount Approved By<span className="astrisk">*</span>
                                                        </label>
                                                        <Select
                                                            classNamePrefix="select"
                                                            isSearchable
                                                            isMulti                               // ✅ allow multiple selection
                                                            name="employees"
                                                            options={helpdeskperson?.map(emp => ({
                                                                value: emp.id,
                                                                label: emp.name,
                                                            }))}
                                                            placeholder="-- Select Employees --"
                                                            value={
                                                                helpdeskperson
                                                                    ?.map(emp => ({
                                                                        value: emp.id,
                                                                        label: emp.name,
                                                                    }))
                                                                    .filter(option => selectedEmployeeIds.includes(option.value)) // ✅ handle multiple
                                                            }
                                                            onChange={(selectedOptions) =>
                                                                setSelectedEmployeeIds(selectedOptions?.map(opt => opt.value) || [])
                                                            }
                                                            menuPortalTarget={document.body}
                                                            styles={reactSelectStyles}
                                                            menuPlacement="auto"
                                                            menuPosition="absolute"
                                                        />
                                                    </div>




                                                </div>


                                            </div>

                                            <div className="row mb-2 mt-1 align-items-center">
                                                <div className="col-md-4">
                                                    <label className="form-labell">
                                                        Occurrences <span className="astrisk">*</span>
                                                    </label>

                                                    <div className="d-flex gap-3 mt-2">
                                                        <label className="d-flex align-items-center gap-2">
                                                            <input
                                                                type="radio"
                                                                name="occurrence"
                                                                checked={occurrence === "one_time"}
                                                                onChange={() => {
                                                                    setOccurrence("one_time");
                                                                    setSelectedSemesters([]); // reset
                                                                }}
                                                            />
                                                            One Time
                                                        </label>

                                                        <label className="d-flex align-items-center gap-2">
                                                            <input
                                                                type="radio"
                                                                name="occurrence"
                                                                checked={occurrence === "each_time"}
                                                                onChange={() => setOccurrence("each_time")}
                                                            />
                                                            Each Occurrence
                                                        </label>
                                                    </div>
                                                </div>
                                                {occurrence === "each_time" && (
                                                    <div className="col-md-8 mt-3">
                                                        <label className="form-labell">
                                                            Select Semesters <span className="astrisk">*</span>
                                                        </label>

                                                        <div className="d-flex flex-wrap gap-3 mt-2">
                                                            {semesterOptions.map((sem) => (
                                                                <label
                                                                    key={sem.value}
                                                                    className="d-flex align-items-center gap-2"
                                                                >
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={selectedSemesters.includes(sem.value)}
                                                                        onChange={(e) => {
                                                                            if (e.target.checked) {
                                                                                setSelectedSemesters((prev) => [
                                                                                    ...prev,
                                                                                    sem.value
                                                                                ]);
                                                                            } else {
                                                                                setSelectedSemesters((prev) =>
                                                                                    prev.filter((id) => id !== sem.value)
                                                                                );
                                                                            }
                                                                        }}
                                                                    />
                                                                    {sem.label}
                                                                </label>

                                                            ))}
                                                        </div>
                                                    </div>
                                                )}

                                            </div>

                                            {/* Footer row */}
                                            <div className="row mb-2 mt-3 align-items-center">
                                                <div className="col-md-6">

                                                </div>
                                                <div className="col-md-6 d-flex justify-content-end gap-3">
                                                    <button
                                                        onClick={handleCancel}
                                                        style={{
                                                            backgroundColor: '#f44336',
                                                            color: '#fff',
                                                            border: 'none',
                                                            padding: '6px 30px',
                                                            borderRadius: '6px',
                                                            fontWeight: '500',
                                                            cursor: 'pointer',
                                                            transition: 'background-color 0.3s ease'
                                                        }}
                                                    >
                                                        Cancel
                                                    </button>

                                                    <button
                                                        className="add-btn"
                                                        onClick={handleBeforeSubmit}
                                                        disabled={!isFormValid}   // ✅ disable when not valid
                                                        style={{
                                                            opacity: !isFormValid ? 0.6 : 1,
                                                            cursor: !isFormValid ? "not-allowed" : "pointer",
                                                            background: !isFormValid ? '#d3d3d3' : '#7F56DA'
                                                        }}
                                                    >
                                                        Create Discount
                                                    </button>
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </div>

                            </div>
                        </div>


                    </div>
                </div>

            </div>

            <FeePlanModal
                isOpen={showFeePlanModal}
                onClose={() => setShowFeePlanModal(false)}
                studentName={selectedStudentName}
                feePlan={selectedFeePlan}
                setWidth="50%"
            />



            <ConfirmationModal
                isOpen={confirmationModalOpen}
                title="Confirm Submission"
                message="Are you sure you want to send the approval message to the assigned person via WhatsApp?"
                onConfirm={handleConfirmFeePlan}
                onCancel={handleCancelFeePlan}
                showCheckbox={false} // or true if you want the checkbox option
                isSubmitting={isSubmitting}
            />

            <OtpModal
                isOpen={otpModalOpen}
                onConfirm={handleConfirmOtp}
                onCancel={handleCancelOtp}
                studentResponse={studentResponse}
                onResend={handlesResendOtpToAssignedPerson}
                reverifyDiscountOtp={helpdeskperson}
                skipSelectOnResend={true}
                hideOtpInput={true}
            />


            {previewOpen && (
                <DiscountPreviewModal
                    isOpen={previewOpen}
                    previewData={previewData}
                    onClose={() => setPreviewOpen(false)}
                    onConfirm={handleConfirmFeePlan}
                    isSubmitting={isSubmitting}
                    selectedSessionName={selectedSession?.label || ""}
                    onContinue={() => {
                        setPreviewOpen(false);
                        setConfirmationModalOpen(true);
                    }}
                />
            )}



            <WaitFeeApprovalsModal isOpen={showWaittingModal}
                // feePlanId={specializationSubmitResponse?.unique_id}
                studentResponse={studentResponse}
                onClose={() => {
                    setConfirmationModalOpen(false)
                    setShowWaitingModal(false)
                    navigate(-1)
                }} />

        </>
    );
};


